// extracted by mini-css-extract-plugin
module.exports = {"root":"GlobalHeader_root__EygkN"};